export const getIsClient = (state) => state.general.isClient;
export const getIsAdmin = (state) => state.general.isAdmin;
export const getIsUnderMaintenance = (state) => state.general.isUnderMaintenance;
